import { render } from "./DeleteCommune.vue?vue&type=template&id=20633be3&scoped=true"
import script from "./DeleteCommune.vue?vue&type=script&lang=js"
export * from "./DeleteCommune.vue?vue&type=script&lang=js"

import "./DeleteCommune.vue?vue&type=style&index=0&id=20633be3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20633be3"]])

export default __exports__